import { Outlet, createFileRoute } from "@tanstack/react-router";
import { OnboardingLayout } from "@/components/layout/OnboardingLayout";

export const Route = createFileRoute("/_onboarding")({ component: OnboardingRouteLayout });

function OnboardingRouteLayout() {
  return (
    <OnboardingLayout>
      <Outlet />
    </OnboardingLayout>
  );
}
